<div *ngFor="let innerField of innerFields">
    <span style="font-weight:600">{{innerField?.title}}</span> : {{innerField?.value}}
</div>
